type SpanPropertiesType = {
  attributes: { "workflow.name": string; [key: string]: any };
};

export type SpanType = {
  end: () => void;
};

let tracer: {
  startSpan: (name: string, properties: SpanPropertiesType) => SpanType;
};

const tracerName = "hp-all-in-one-plan";

//Usage startSpan?.("your-data")
export function startSpan(attributes: SpanPropertiesType["attributes"]) {
  if (!tracer) {
    const splunkRum = (window as any)?.SplunkRum;
    tracer = splunkRum?.provider?.getTracer?.(tracerName);
  }

  tracer
    ?.startSpan?.("hp-all-in-one-plan", {
      attributes,
    })
    .end();

  return {};
}
